import { useLocation } from '@reach/router';

// real dumb until we get more languages
export default function useCurrentLanguage() {
  const { pathname } = useLocation();
  const isFr = pathname.startsWith('/fr');
  return isFr ? 'fr' : 'en';
}
